import { render, staticRenderFns } from "./BasicActivation.vue?vue&type=template&id=38e8f3be&scoped=true&"
import script from "./BasicActivation.vue?vue&type=script&lang=js&"
export * from "./BasicActivation.vue?vue&type=script&lang=js&"
import style0 from "./BasicActivation.vue?vue&type=style&index=0&id=38e8f3be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e8f3be",
  null
  
)

export default component.exports